import { Box, Container, Typography, Paper } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import CloudIcon from '@mui/icons-material/Cloud';
import GitHubIcon from '@mui/icons-material/GitHub';
import StorageIcon from '@mui/icons-material/Storage';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import WebIcon from '@mui/icons-material/Web';

const techStack = [
  { name: 'React', icon: <WebIcon />, description: 'Used for building responsive web and cross-platform mobile apps with shared UI components and logic.' },
  { name: 'React Native', icon: <PhoneIphoneIcon />, description: 'Framework for building native mobile apps using React, allowing code sharing between web and mobile.' },
  { name: 'TypeScript', icon: <CodeIcon />, description: 'Superset of JavaScript that adds static types, enhancing code quality and maintainability.' },
  { name: 'Node.js', icon: <CodeIcon />, description: 'JavaScript runtime for building scalable server-side applications, enabling full-stack JavaScript development.' },
  { name: 'PostgreSQL', icon: <StorageIcon />, description: 'Relational database management system used for storing structured data with advanced querying capabilities.' },
  { name: 'AWS', icon: <CloudIcon />, description: 'Cloud platform providing scalable infrastructure and services for hosting applications, databases, and storage.' },
  { name: 'GitHub', icon: <GitHubIcon />, description: 'Version control platform for managing code repositories, facilitating collaboration and versioning of projects.' },
];

export default function TechStackPage() {
  return (
    <Box sx={{ py: 8, background: 'rgb(237, 236, 235)', minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Typography variant="h3" fontWeight={700} textAlign="center" mb={6}>
          Tech Stack
        </Typography>
        <Typography variant="h6" color="" textAlign="center" mb={4} >
          Our technology stack combines modern frameworks and tools to deliver high-quality applications.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            justifyContent: 'center',
          }}
        >
          {techStack.map((tech) => (
            <Paper
              key={tech.name}
              elevation={2}
              sx={{
                width: 250,
                height: 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                borderRadius: 3,
                backgroundColor: '#ffffff',
              }}
            >
              <Box sx={{ fontSize: 40 }}>{tech.icon}</Box>
              <Typography variant="subtitle1" fontWeight={600}>
                {tech.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ px: 1 }}>
                {tech.description}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
